<template>
  <v-app v-resize="adjust_size">
    <div class="background">
      <vue-particles 
        color="#DC143C" 
        :particleOpacity="0.7"
        :particlesNumber="60"
        :particleSize="3"
        :moveSpeed="3"
        lineColor="#DC143C"
        :lineOpacity="0.5"
        >
      </vue-particles>
    </div>
    <v-content style="z-index: 1" class="app">
      <MainPage/>
    </v-content>
    <v-footer height="auto" class="footer">
      <v-spacer></v-spacer>
      <div class="footer-menu">&copy; Dater Garment Industri {{new Date().getFullYear()}}</div>
    </v-footer>  
  </v-app>
</template>

<script>
import MainPage from './components/MainPage.vue'

export default {
  data () {
    return {
      title: 'Vuetify.js',
      screen: {
        x: 0,
        y: 0
      }
    }
  },
  name: 'App',
  mounted() {
    this.adjust_size()
  },
  methods: {
    adjust_size() {
      this.screen = {x : window.innerWidth, y: window.innerHeight}
    },
    adjust_height() {
      return this.screen.x < 950 ? '2.25em' : '8em'
    }
  },
  components: {
    MainPage
  }
}
</script>
<style>
.app {
  margin-left: 8%;
  margin-right: 8%;
}
.background{
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 0;
}
.header{
  max-width: 100%;
}
.header-menu-large{
  font-family: 'Raleway', sans-serif;
  font-size: 1.2em;
  line-height: 5em;
}
.header-menu-small{
  line-height: 5em;
  font-family: 'Raleway', sans-serif;
  font-size: 1em;
}
.header-menu-mobile{
  line-height: 6em;
  font-family: 'Raleway', sans-serif;
  font-size: 0.6em
}
.footer {
  transform: translateY(10em)
}
.footer-menu{
  font-family: 'Raleway', sans-serif;
  font-size: 10px;
  font-weight: 300;
  padding-right: 2em;
}
.small{
  min-height: 2.25em;
}
.large{
  min-height: 5em;
}
.mobile{
  min-height: 2em;
}
.small-icon{
  height: 3.25em;
}
.large-icon{
  height: 4em;
}
.mobile-icon {
  height : 2em;
}
.header-select{
  padding: 0 1em 0 1em;
  text-decoration: none;
  color: black;
}
#particles-js {
  width: 100%;
  height: 100vh;
}
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>
 


// WEBPACK FOOTER //
// src/App.vue